"use client";
import React from "react";
import { RiInformationLine } from "react-icons/ri";
import { MetabaseConnectionData } from "~/lib/network/metabase-connection";
import { LuChevronRight } from "react-icons/lu";

type CredentialsFormProps = {
  formData: MetabaseConnectionData;
  onInputChange: (field: keyof MetabaseConnectionData, value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  isLoading: boolean;
  isFormValid: () => string;
  isSuccessful: boolean;
  handleNext: () => void;
};

export default function CredentialsForm({
  formData,
  onInputChange,
  onSubmit,
  isLoading,
  isFormValid,
  isSuccessful,
  handleNext,
}: CredentialsFormProps) {
  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div className="flex flex-col gap-4 items-center">
        <div className="mt-6 form-control w-full max-w-md">
          <label className="label my-2">
            <span className="label-text font-medium">Metabase URL</span>
            <span className="label-text-alt text-red-500">*</span>
            <div
              className="tooltip tooltip-right"
              data-tip="Your Metabase instance URL (e.g., https://metabase.yourcompany.com)"
            >
              <RiInformationLine className="text-gray-500" />
            </div>
          </label>
          <input
            type="url"
            placeholder="https://metabase.yourcompany.com"
            className="input input-bordered w-full"
            value={formData?.metabaseUrl}
            onChange={(e) => onInputChange("metabaseUrl", e.target.value)}
            required
          />
        </div>

        <div className="form-control w-full max-w-md">
          <label className="label my-2">
            <span className="label-text font-medium">API Key</span>
            <span className="label-text-alt text-red-500">*</span>
            <div
              className="tooltip tooltip-right"
              data-tip="API key generated from your Metabase admin settings"
            >
              <RiInformationLine className="text-gray-500" />
            </div>
          </label>
          <input
            type="password"
            placeholder="mb_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
            className="input input-bordered w-full"
            value={formData?.apiKey}
            onChange={(e) => onInputChange("apiKey", e.target.value)}
            required
          />
        </div>
      </div>

      <div className="flex justify-center mt-10">
        <div className="w-full max-w-md flex items-center gap-2">
          <button
            type="submit"
            className="btn btn-neutral bg-purple-600 text-white hover:bg-purple-500 flex-1"
            disabled={!isFormValid()}
          >
            {isLoading ? (
              <span className="loading loading-spinner"></span>
            ) : (
              "Connect to Metabase"
            )}
          </button>
          <button
            type="button"
            className="btn btn-neutral bg-purple-600 text-white hover:bg-purple-500"
            disabled={!isSuccessful}
            onClick={handleNext}
          >
            <LuChevronRight className="w-6 h-6" />
          </button>
        </div>
      </div>
    </form>
  );
}
